import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { userStickersQueryOptions } from '@/hooks/stickers/use-user-stickers';
import type { RespondedType, ResponseError } from '@/models/response';
import { addTranslateToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useDeleteStickers() {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, number[]>({
    mutationKey: ['/DeleteSticker'],
    mutationFn: (stickerIds) =>
      fetcher<RespondedType>('/DeleteSticker', { StickerIds: stickerIds }, { validResponseCodes: [0] }),
    onSuccess: (_, stickerIds) => {
      queryClient.setQueryData(userStickersQueryOptions.queryKey, (state) =>
        produce(state, (draft) => {
          if (!draft) return draft;

          draft.Stickers = draft.Stickers.filter((sticker) => !stickerIds.includes(sticker.Id));
        }),
      );

      addTranslateToast({
        type: 'success',
        message: 'common.delete-success',
      });
    },
    onError: () => {
      addTranslateToast({
        type: 'error',
        message: 'common.delete-failed',
      });
    },
  });
}
